class Loader {
    constructor({
        assets,
        onComplete,
        onProgress,
        onError
    }) {
        this.assets = assets;
        this.assets_loaded = 0;
        this.onComplete = onComplete;
        this.onProgress = onProgress;
        this.onError = onError;

        this.delay = 0;

        if(typeof window.assets === 'undefined')
            window.assets = {
                images: {},
                sounds: {}
            }

        return this;
    }

    progress(object) {
        this.assets_loaded++;

        if(typeof this.onProgress === 'function')
            this.onProgress(this.assets_loaded / this.assets.length);

        if(this.assets_loaded === this.assets.length)
            this.onComplete();
    }

    load(object) {
        if(typeof object === 'string') {
            const file_type = object.split('.')[1];

            if(['css'].includes(file_type)) object = {path: object, type: 'style'};
            if(['mp3', 'wav'].includes(file_type)) object = {path: object, type: 'audio'};
            if(['mp4'].includes(file_type)) object = {path: object, type: 'video'};
            if(['mp3'].includes(file_type)) object = {path: object, type: 'audio'};
            if(['woff2', 'woff', 'ttf'].includes(file_type)) object = {path: object, type: 'fonts'};
            if(['png', 'jpg', 'jpeg', 'svg', 'ico', 'gif'].includes(file_type)) object = {path: object, type: 'image'}; 
        }

        // console.log(object);
        if(object.type == 'image') this.loadImage(object);
        if(object.type == 'video') this.loadVideo(object);
        if(object.type == 'audio') this.loadAudio(object);
        if(object.type == 'fonts') this.loadFonts(object);
    }


    async start(delay) {
        if(delay > 0)
            await (new Promise((resolve) => setTimeout(resolve, delay, true)));

        for(const asset of this.assets)
            this.load(asset);
    }

    loadImage(object) {
        const image = new Image();
              image.src = object.path;

        image.onload = () => {
            document.getElementById('preloaded').append(image);
            window.assets.images[object.path] = image;

            this.progress(object)
        };

        image.onerror = e => console.log(e, object.path);
    }

    loadFonts(object) {
        fetch(object.path)
            .then(response => response.arrayBuffer())
            .then(font => {
                const fontFace = new FontFace(object.family, font);
                document.fonts.add(fontFace);
                this.progress(object);
            }).catch(e => {
                this.onError(object);
            })
    }

    loadVideo(object) {
        fetch(object.path)
            .then(response => response.arrayBuffer())
            .then(font => {
                this.progress(object);
            }).catch(e => {
                this.onError(object);
            })
    }

    loadAudio(object) {
        const audio = new Audio(`${window.location.origin}${object.path.path}`),
              path = object.path.path.split('/');

        audio.onloadedmetadata = () => {
            window.assets.sounds[path[path.length - 1].split('.')[0]] = audio;
            this.progress(object)
        };

        audio.onerror = e => console.log(e);
    }


}

export default Loader;